/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_MenuInputs */



/**
* | output |
* | --- |
* | "Help menu" |
*
* @param {Help_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const help_menu = /** @type {((inputs?: Help_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Menu aide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hilfemenü")
	if (locale === "it") return /** @type {LocalizedString} */ ("Menu di aiuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("меню справки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Menú de ayuda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帮助菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ヘルプメニュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहायता मेनू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Menu de ajuda")
	return /** @type {LocalizedString} */ ("Help menu")
});